import { combineReducers, createSlice } from '@reduxjs/toolkit'
import { accountOperAccessPermAdd, accountOperAccessPermDelete } from './account-oper.actions'

export interface AccountOperState {
  status: 'idle' | 'loading' | 'loaded' | 'failed'
  data: Record<string, any>
  error: string | null
}

const initialState = {
  status: 'idle',
  data: {},
  error: null,
}

export const createReducers = () => {
  const reducers = [accountOperAccessPermAdd, accountOperAccessPermDelete].map((r) => ({
    [r.pending.toString()]: (state) => {
      state.status = 'loading'
    },
    [r.fulfilled.toString()]: (state, action) => {
      state.status = 'loaded'
      state.data = action.payload
    },
    [r.rejected.toString()]: (state) => {
      state.status = 'failed'
      state.error = 'Failed to load'
    },
  }))

  return reducers.reduce((obj, r) => ({ ...obj, ...r }), {})
}

export const accountOperReducer = createSlice({
  name: 'accountOper',
  initialState,
  reducers: {},
  extraReducers: createReducers(),
}).reducer

export const accountOperReducers = combineReducers({
  accountOper: accountOperReducer,
})
